// extracted by mini-css-extract-plugin
export default {"root":"TextInput_root__JHLM6"};